import React from 'react';

import { Title } from '@gerdau/hefesto';
import { UserDataLink } from '../../../services/UserEvaluation/types';
import { UserEvaluationStrong, UserEvaluationTitle } from '../styles';

interface UserDataProps {
  user: UserDataLink;
  showHeader: boolean;
}

const UserData: React.FC<UserDataProps> = ({ user, showHeader }) => {
  return (
    <section>
      {showHeader && (
        <header>
          <UserEvaluationTitle>
            <Title level={4}>Dados do cliente</Title>
          </UserEvaluationTitle>
        </header>
      )}

      <div className="content">
        <span className="item">
          <UserEvaluationStrong>Responsável: </UserEvaluationStrong>
          {user.userName}
        </span>
        <span className="item">
          <UserEvaluationStrong>Razão social: </UserEvaluationStrong>
          {user.companyName}
        </span>
        <span className="item">
          <UserEvaluationStrong>BP:</UserEvaluationStrong> {user.bp}
        </span>
        <span className="item">
          <UserEvaluationStrong>Telefone:</UserEvaluationStrong> {user.phone}
        </span>
        <span className="item">
          <UserEvaluationStrong>E-mail:</UserEvaluationStrong> {user.email}
        </span>
        <span className="item">
          <UserEvaluationStrong>CNPJ:</UserEvaluationStrong> {user.cnpj}
        </span>
      </div>
    </section>
  );
};

export default UserData;
